/*
 * Standards Hub — "Study at a glance" accordion (sections/standards-study.liquid).
 * Desktop (≥990px, panel beside the list): one study open at a time — opening
 * a study closes the others, clicking the open study closes it; the first
 * study is open initially. Mobile: every study starts open and each one
 * toggles on its own (client decision 2026-09-30).
 */
if (!customElements.get('standards-study')) {
  customElements.define(
    'standards-study',
    class StandardsStudy extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.std-study__item'));
        this.desktop = window.matchMedia('(min-width: 990px)');
        if (this.desktop.matches) this.items.forEach((item, index) => this.setOpen(item, index === 0));
        this.classList.add('is-ready');
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('.std-study__trigger');
          if (!trigger || !this.contains(trigger)) return;
          const item = trigger.closest('.std-study__item');
          const opening = !item.classList.contains('is-open');
          // Closing a study above the clicked one shortens the page above it,
          // which would slide the clicked row up out of view. Scroll by the
          // same amount so the row stays where it was clicked.
          const before = trigger.getBoundingClientRect().top;
          if (this.desktop.matches) {
            this.items.forEach((other) => this.setOpen(other, opening && other === item));
          } else {
            this.setOpen(item, opening);
          }
          const shift = trigger.getBoundingClientRect().top - before;
          if (shift) window.scrollBy({ top: shift, behavior: 'instant' });
        });
      }

      setOpen(item, open) {
        const trigger = item.querySelector('.std-study__trigger');
        const panel = item.querySelector('.std-study__panel');
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
      }
    }
  );
}
